import { useEffect, useState } from 'react';
import { adminOrdersAccess } from './api';

/**
 * Whether the signed-in user is a Container Trader admin (CT_WHOLESALE_ADMIN_USER_IDS on the
 * server). Asked once per user per page load and shared by every component that needs it.
 * Only used to show admin links; every admin API checks again on the server.
 */
const answers = new Map();

const askServer = userId => {
  if (!answers.has(userId)) {
    answers.set(
      userId,
      adminOrdersAccess()
        .then(r => !!(r && r.isAdmin))
        .catch(() => {
          answers.delete(userId);
          return false;
        })
    );
  }
  return answers.get(userId);
};

export const useIsCtAdmin = currentUser => {
  const userId = currentUser && currentUser.id && currentUser.id.uuid;
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    if (!userId) {
      setIsAdmin(false);
      return undefined;
    }
    let live = true;
    askServer(userId).then(v => {
      if (live) setIsAdmin(v);
    });
    return () => {
      live = false;
    };
  }, [userId]);
  return isAdmin;
};
